import type { PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  AdminStudentResponse,
  AdminStudentListParams,
  ForceArchiveStudentPayload,
  AdminStudentStatsResponse,
} from "~/types/admin/student";

class AdminStudentModule extends HttpFactory {
  async getStudents(
    params: AdminStudentListParams = {},
  ): Promise<PaginatedResponse<AdminStudentResponse>> {
    return await this.get<PaginatedResponse<AdminStudentResponse>>(
      ENDPOINTS.ADMIN.PROFILES.STUDENTS,
      params,
    );
  }

  async getStudent(id: number): Promise<AdminStudentResponse> {
    return await this.get<AdminStudentResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.STUDENTS}${id}/`,
    );
  }

  async forceArchive(
    id: number,
    payload: ForceArchiveStudentPayload = {},
  ): Promise<AdminStudentResponse> {
    return await this.post<AdminStudentResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.STUDENTS}${id}/force_archive/`,
      payload,
    );
  }

  async forceUnarchive(id: number): Promise<AdminStudentResponse> {
    return await this.post<AdminStudentResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.STUDENTS}${id}/force_unarchive/`,
      {},
    );
  }

  async updateArchiveStatus(
    id: number,
    data: { is_archived?: boolean; archived_at?: string | null },
  ): Promise<AdminStudentResponse> {
    return await this.patch<AdminStudentResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.STUDENTS}${id}/`,
      data,
    );
  }

  async getStats(): Promise<AdminStudentStatsResponse> {
    return await this.get<AdminStudentStatsResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.STUDENTS}stats/`,
    );
  }
}

export default AdminStudentModule;
